import React from 'react';
import './App.css';
import './ant.less';
import HomePage from "./page/HomePage";

window.settingUpdate = function (content) {
    if (window.settingCallBack !== undefined) {
        window.settingCallBack.settingUpdate(content)
    }
}

window.setSettingCallBack = function (callback) {
    window.settingCallBack = callback
}



class App extends React.Component {

    render() {
        return (
            <HomePage/>
        )
    }

}

export default App
